<template>
    <div class="widget-sound-settings">
        <RedesignFormItem
            :label="$t('widget.config.maximumWarningCallersValue')"
        >
            <RedesignInputNumber
                v-model="soundModel.maximumWarningCallersValue"
                :max-value="100"
                :min-value="0"
                :step="1"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="$t('widget.config.maximumLimitCallersValue')"
        >
            <RedesignInputNumber
                v-model="soundModel.maximumLimitCallersValue"
                :max-value="100"
                :min-value="0"
                :step="1"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="$t('widget.config.maximumWarningMaxRingTimeValue')"
        >
            <base-time-input
                v-model="soundModel.maximumWarningMaxRingTimeValue"
                :min-value="0"
                :step="1"
                class="input-number"
                max-width="200px"
                color="primary"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="$t('widget.config.maximumLimitMaxRingTimeValue')"
        >
            <base-time-input
                v-model="soundModel.maximumLimitMaxRingTimeValue"
                :min-value="0"
                :step="1"
                class="input-number"
                max-width="200px"
                color="primary"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="$t('settings.maximumWarningCallersColor')"
        >
            <RedesignWidgetColor
                v-model="soundModel.maximumWarningCallersColor"
                :predefine="predefinedColors"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="$t('settings.maximumLimitCallersColor')"
        >
            <RedesignWidgetColor
                v-model="soundModel.maximumLimitCallersColor"
                :predefine="predefinedColors"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="$t('settings.maximumWarningMaxRingTimeColor')"
        >
            <RedesignWidgetColor
                v-model="soundModel.maximumWarningMaxRingTimeColor"
                :predefine="predefinedColors"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="$t('settings.maximumLimitMaxRingTimeColor')"
        >
            <RedesignWidgetColor
                v-model="soundModel.maximumLimitMaxRingTimeColor"
                :predefine="predefinedColors"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="$t('settings.maximumWarningCallersSound')"
        >
            <SoundSelect
                v-model="soundModel.maximumWarningCallersSound"
                :placeholder="String($t('settings.maximumWarningCallersSound'))"
                :options="warningSoundList"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="$t('settings.maximumLimitCallersSound')"
        >
            <SoundSelect
                v-model="soundModel.maximumLimitCallersSound"
                :placeholder="String($t('settings.maximumLimitCallersSound'))"
                :options="errorSoundList"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="$t('settings.maximumWarningMaxRingTimeSound')"
        >
            <SoundSelect
                v-model="soundModel.maximumWarningMaxRingTimeSound"
                :placeholder="String($t('settings.maximumWarningMaxRingTimeSound'))"
                :options="warningSoundList"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="$t('settings.maximumLimitMaxRingTimeSound')"
        >
            <SoundSelect
                v-model="soundModel.maximumLimitMaxRingTimeSound"
                :placeholder="String($t('settings.maximumLimitMaxRingTimeSound'))"
                :options="errorSoundList"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="$t('settings.backQueueSLASound')"
        >
            <SoundSelect
                v-model="soundModel.backQueueSLASound"
                :placeholder="String($t('settings.backQueueSLASound'))"
                :options="allSoundList"
            />
        </RedesignFormItem>
    </div>
</template>

<script setup lang="ts">
import { WidgetLayout } from '@/types/dashboard'
import { useVModel } from '@vueuse/core'
import RedesignFormItem from '@/components/RedesignBaseComponents/Form/RedesignFormItem.vue'
import RedesignInputNumber from '@/components/RedesignBaseComponents/Inputs/RedesignInputNumber.vue'
import BaseTimeInput from '@/components/Common/BaseTimeInput.vue'
import RedesignWidgetColor from '@/components/RedesignComponents/Widgets/Common/RedesignWidgetColor.vue'
import { predefinedColors } from '@/views/DashboardSettings/LayoutManagement/layout-management'
import SoundSelect from '@/components/Common/SoundSelect.vue'
import { allSoundList, errorSoundList, warningSoundList } from '@/composables/globalData/useEntitiesData'

const props = defineProps<{
    value: WidgetLayout
}>()

const emit = defineEmits([ 'input' ])

const soundModel = useVModel(props, 'value', emit, { eventName: 'input' })
</script>
